'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import ReactMarkdown from 'react-markdown';

import {InfoCircleFill} from "react-bootstrap-icons";

import Alert from 'react-bootstrap/Alert';

import {isEmpty} from "./Utils";
import bannerMessagesStore from "./BannerMessagesStore";
import SimpleState from "./SimpleState";
import appStore from "./AppStore";
import PropTypes from "prop-types";

/**
 * Display banner messages.
 */
class BannerMessages extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = bannerMessagesStore;
    }

    componentDidMount() {
        this.store.loadBannerMessages();
    }

    buildDoneComponent = () => {
        let bannerMessageWidget;
        let additionalComponent;

        if ( this.store.bannerMessages && !isEmpty(this.store.bannerMessages) ) {
            let messages = this.store.bannerMessages;
            let bannerMessages = [];
            Object.keys(this.store.bannerMessages).map( function (key, i) {
                // Display the banner message if it is for ALL or for a specific message group
                if (key !== "" && !(messages[key] === "") && (key === "ALL" || appStore.hasRoles(key) ) ) {
                    // TODO: When implementing the admin console add the following link as a guide for markdown syntax
                    //https://blog.logrocket.com/how-to-safely-render-markdown-using-react-markdown/
                    bannerMessages.push(<ReactMarkdown children={messages[key]} key={i}/>)
                }
            },this);

            if (bannerMessages && bannerMessages.length > 0) {
                bannerMessageWidget =
                    <Alert variant="info"
                           className="app-banner-messages d-print-none px-3 py-2 mb-0 border-0 rounded-0 d-flex align-items-start">
                        <InfoCircleFill aria-hidden={true} className="me-2 fs-5"/>
                        <div className="messages">{bannerMessages}</div>
                    </Alert>;
            }
        }

        if (this.props.additionalComponent) {
            additionalComponent = this.props.additionalComponent;
        }

        return (
            <>
                {bannerMessageWidget}
                {additionalComponent}
            </>
        );
    }
    buildPendingComponent = () => {
        return (
            <span className="sr-only">Loading Messages...</span>
        );
    }

    render() {
        return <SimpleState state={this.store.state} doneComponentBuilder={this.buildDoneComponent} pendingComponentBuilder={this.buildPendingComponent} name="BannerMessages"/>;
    }
}

BannerMessages.propTypes = {
    additionalComponent: PropTypes.node // if there are any other app-specific messages that need to be displayed as part of the banner message. Eg: adviser session view message
}

BannerMessages.defaultProps = {
    additionalComponent: null
};

export default observer(BannerMessages);
